<div class="img-container flex flex-row flex-center-center">
  <img #img src="{{getUrl()}}" alt="{{alt}}" class="{{maxHeight}}">
</div>
